import { Component, OnInit, Injector }        from '@angular/core';
import { ZimbraInstanceService } from 'src/app/_service/zimbrainstance.service';
import { LoggedBaseComponent }                from '../../_components/LoggedBaseComponent';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends LoggedBaseComponent implements OnInit {

  loading       : boolean = false;
  call_end      : boolean = false;
  is_migrating  : boolean = false;

  constructor(  
    private injector              : Injector,
    private _zimbraInstanceService : ZimbraInstanceService
  ) 
  { 
    super(injector);
  }

  ngOnInit() 
  {
    // this.whoAmI();


    // this.zimbraLogin();

    var stored_user_info = this._userService.getLoggedUser();
    if (stored_user_info["zimbra_instance_id"] === null)
    {
      this.is_migrating = true;
    }

    // var redirect_to = this._route.snapshot.queryParams['path'];
    // // console.log(redirect_to);

    // if (!this._userService.isLogged())
    // {
    //   this._router.navigate(['']);
    // }
  }

  whoAmI()
  {
    this.loading      = true;
    this.is_migrating = false;
    this._userService.getUserInfo().subscribe(
          data => {
            this.loading = false;
            this.call_end = true;
            if (data["retdata"]["data"]["zimbra_instance_id"] === null)
            {
               this.is_migrating = true;
            }
            // else
            // {
            //     this.zimbraLogin();
            // }
            // console.log(data);
          },
          err => {
            this.loading = false;
            this.call_end = true;
            this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
        })
  }

  zimbraLogin()
  {
    this._zimbraInstanceService.zimbraLogin().subscribe(
      data => {
          window.open(data["retdata"]["data"], "_self");
      },
      err => {
        this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
    })
  }

}
